export var PMS;
(function (PMS) {
    PMS["RX30"] = "rx30";
    PMS["COMPUTER_RX"] = "computerrx";
    // PIONEER_RX is the value used in our database in the 'pms' column
    PMS["PIONEER_RX"] = "pioneerrx";
    // PIONEER is the value used by the Pioneer pharmacy management system when they POST
    // their data to the API. The 'pms' query parameter is set to 'pioneer' in the request.
    PMS["PIONEER"] = "pioneer";
    PMS["BEST_RX"] = "bestrx";
    PMS["LIBERTY"] = "liberty";
    PMS["ENTERPRISE"] = "enterprise";
    PMS["QS1"] = "qs1";
    PMS["DRX"] = "drx";
    PMS["OTHER"] = "other";
})(PMS || (PMS = {}));
export var PMS_LABEL;
(function (PMS_LABEL) {
    PMS_LABEL["TDS_RX30"] = "TransactionDataSystems-Rx30";
    PMS_LABEL["RX30"] = "Rx30";
    PMS_LABEL["PIONEER_RX"] = "PioneerRx";
    PMS_LABEL["PIONEER"] = "Pioneer";
    PMS_LABEL["LIBERTY"] = "Liberty";
    PMS_LABEL["COMPUTER_RX"] = "ComputerRX-WinRx";
    PMS_LABEL["DRX"] = "DRX";
})(PMS_LABEL || (PMS_LABEL = {}));
